export const REQUIRED_FIELDS_NOT_FILLED_TIP = "You must choose all required values to continue.";
export const PARENT_AND_CHILD_MARKET_REQUIRED_TIP = "You must choose a Parent Market and at least one Child Market to continue.";

export const CPS_OUTLET = 'CPS Outlet';

// Market Selection Types
export const MARKET_SELECTION_TYPE = {
    PANEL_TOTAL_US_MARKETS: 'Panel Total US Markets',
    PANEL_BY_CHANNEL: 'Panel By Channel',
    TOTAL_US: 'Total US',
    BY_CHANNEL_FMCG: 'By Channel FMCG',
    BY_CHANNEL_SPECIALITY: 'By Channel Speciality',
    BY_GEOGRAPHY: 'By Geography',
} as const;

export const NO_STORES_MARKET = ['All Other Stores'];

// Configuration for SKUs that require advanced shift select and max selections
export const ADVANCED_SHIFT_SELECT_SKUS = ['38'];
export const ADVANCED_SHIFT_SELECT_MAX_SELECTIONS = 10;
